module.exports = __webpack_public_path__ + "img/section4Logo1.50734820.png";